import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { Slide } from 'pure-react-carousel';
import ReactHtmlParser from 'react-html-parser';
import fontSize from 'modules/actions/fontSize';

/**
 * Text
 */
const ListBtnElement = ({ onClickEvt, data, styleDef }) => {
  const buttonStyle = {
    "display": "inline-block",
    "width": "100%",
    "textAlign": "left",
    fontSize: styleDef.fontSize
  }
  return (
    <button type="button" className="_list_btn_button" style={buttonStyle} onClick={e => onClickEvt(data.value, data.action, data.label)}>
      {ReactHtmlParser(data.label)}
    </button>
  );
};
const ListButtonTitle = ({ boxStyle, item, viewType, onClickEvt }) => {
  const { items, type } = item;
  return (
    <>
    {
      items[0].button[0].label && (
        <div className="_list_btn">
        {
          items[0].text.desc && (
            <div className="_title" style={boxStyle}>
              {ReactHtmlParser(items[0].text.desc)}
            </div>
        )}
        {items[0].button.map((data, number) => {
          if (data.label) {
            return <ListBtnElement key={'list_btn_ele_' + number} styleDef={boxStyle} onClickEvt={onClickEvt} data={data} />;
          }
          return null;
        })}
      </div>
      )
    }
    </>
  );
};
ListButtonTitle.propTypes = {
  boxStyle: PropTypes.object,
  item: PropTypes.object,
  viewType: PropTypes.string,
  onClickEvt: PropTypes.func,
};
ListButtonTitle.defaultProps = {
  boxStyle: {},
  item: {},
  viewType: 'advise', // advise, simulator, knowledge
  onClickEvt: null,
};

ListBtnElement.propTypes = {
  data: PropTypes.object,
  onClickEvt: PropTypes.func,
  styleDef: PropTypes.object,
};
ListBtnElement.defaultProps = {
  data: {},
  onClickEvt: null,
  styleDef: {},
};

export default ListButtonTitle;
